import axios from 'axios';
import store from '@/store';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Endpoints, Mutations } from '@/ts/store/Constants';
import FeedbackEventData from '@/ts/FeedbackEventData';
import { FeedbackEventsResponse } from '@/ts/HococoInterfaces';
import ErrorResponse from '@/ts/ErrorResponse';

@Module({name: 'Feedback', namespaced: true})
export default class Feedback extends VuexModule {
    public ratingValue: number = 2.5;
    public commentValue: string = '';
    public activeFeedbackEventId: number|null = null;
    public feedbackEvents: FeedbackEventData[] = [];
    public feedbackEventMap: { [index: string]: number } = {};

    @Mutation
    public RESET_FEEDBACK_STORE_STATE(): void {
        this.ratingValue           = 2.5;
        this.commentValue          = '';
        this.activeFeedbackEventId = null;
        this.feedbackEvents        = [];
        this.feedbackEventMap      = {};
    }

    get feedbackDialogVisible(): boolean {
        return this.activeFeedbackEventId !== null;
    }

    get rating(): number {
        return this.ratingValue;
    }

    get comment(): string {
        return this.commentValue;
    }

    get hasRating(): boolean {
        if (typeof this.activeFeedbackEventId !== 'number') {
            return false;
        }

        return this.feedbackEvents[this.activeFeedbackEventId].hasRating;
    }

    get hasComment(): boolean {
        if (typeof this.activeFeedbackEventId !== 'number') {
            return false;
        }

        return this.feedbackEvents[this.activeFeedbackEventId].hasComment;
    }

    @Mutation
    public SET_FEEDBACK_RATING(rating: number) {
        this.ratingValue = rating;
    }

    @Mutation
    public SET_FEEDBACK_COMMENT(comment: string) {
        this.commentValue = comment;
    }

    @Mutation
    public SHOW_FEEDBACK_DIALOG(event: string) {
        this.activeFeedbackEventId = this.feedbackEventMap[event];
    }

    @Mutation
    public HIDE_FEEDBACK_DIALOG() {
        this.activeFeedbackEventId = null;
        this.ratingValue = 2.5;
        this.commentValue = '';
    }

    @Mutation
    public ADD_FEEDBACK_EVENTS(feedbackEvents: FeedbackEventsResponse) {
        let arrayIndex: number = null;

        for (const feedbackEvent of feedbackEvents.data) {
            arrayIndex = this.feedbackEvents.push(new FeedbackEventData(
                feedbackEvent.id,
                feedbackEvent.key,
                feedbackEvent.name,
                feedbackEvent.description,
                feedbackEvent.has_rating,
                feedbackEvent.has_comment,
                feedbackEvent.created_at,
                feedbackEvent.updated_at,
            )) - 1;

            this.feedbackEventMap[feedbackEvent.key] = arrayIndex;
        }
    }

    @Action
    public FETCH_FEEDBACK_EVENTS() {
        axios.get(Endpoints.Users.FEEDBACK_EVENTS)
            .then((response: FeedbackEventsResponse) => {
                store.commit(Mutations.ADD_FEEDBACK_EVENTS, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public SEND_FEEDBACK() {
        const feedbackEventId = Feedback.state.feedbackEvents[Feedback.state.activeFeedbackEventId].id;

        axios.post(Endpoints.Users.USER_FEEDBACK(feedbackEventId), {
            rating: Feedback.state.ratingValue,
            comment: Feedback.state.commentValue,
        })
            .then((response: any) => {
                store.commit(Mutations.HIDE_FEEDBACK_DIALOG);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }
}
